import * as React from "react";
import { Table} from "antd";
import { connect } from "react-redux";
//import moment from "moment";

interface IEmailistProps {
  id:any;
  emaillist:any;
  tabStatus:any;
}

// 修改
class Emailist extends React.Component<IEmailistProps, any> {
  state = {
     list:[]
  };
  constructor(props: IEmailistProps) {
    super(props);
  }

  componentDidMount() {
    this.emaillist();     
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if(nextProps.tabStatus != 'tab5' && !prevState.refresh ){
      this.setState({
        refresh: true,
      });
      return true;
    }
    if(nextProps.tabStatus == 'tab5' && prevState.refresh ){
      this.emaillist();
      return false;
    }
    return true;
  }

  emaillist = () =>{
    this.setState({
      refresh: false,
    });
    const param: any = {
      id: this.props.id
    }; 
    this.props.emaillist({
      ...param,
      callback: (data) => {
        this.setState({
           list: data
        });
      }
     });    
  }

  render() {
    const dataSource = this.state.list;
    
    const columns = [{
      title: '收件人',
      dataIndex: 'mail_to',
      className:'th',
    }, {
      title: '邮件标题',
      dataIndex: 'title',
      className:'th',
    }, {
      title: '附件',
      dataIndex: 'attachment',
      className:'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
                <a href={row.attachment} target="_blank">查看</a>  <a href={row.attachment+'?title='+row.title} target="_blank">下载</a>   <a href={row.attachment+'?title='+row.title} target="_blank">协议</a>
          </React.Fragment>
        );
      }
    }, {
      title: '发送时间',
      dataIndex: 'send_time',
      className:'th',
    }, {
      title: '操作人',
      dataIndex: 'operator',
      key: 'operator',
      className:'th',
    }, {
      title: '发送状态',
      dataIndex: 'send_status',
      key: 'send_status',
      className:'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
                {row.send_status == 1 ? '发送成功' : ''}
          </React.Fragment>
        );
      }
    }, {
      title: '读取状态',
      dataIndex: 'read_status',
      key: 'read_status',
      className:'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
                {row.read_status == 1 ? '读取成功' : ''}
          </React.Fragment>
        );
      }
    }, {
      title: '读取时间',
      dataIndex: 'read_time',
      key: 'read_time',
      className:'th',
    }];

    
    return (
      <React.Fragment>
           <div className="from-email"> 
                   <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSource} columns={columns} />
           </div>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  tabStatus: state.orderDetails.tabStatus,
});

const mapDispatch = dispatch => {
  return {
    emaillist: dispatch.orderDetails.emaillist
  };
};


export default connect(
  mapState ,
  mapDispatch
)(Emailist);
